// extracted by mini-css-extract-plugin
export default {"root":"Progress_root__DzfWr"};